<template>
  <div class="markdown-body">
    <h1>简要概述</h1>
    <p>无论对方说什么，就抓住</p>
    <ol>
      <li>公司辞退我是非法辞退，我有微信聊天证据</li>
      <li>我非常体谅公司并且愿意调解</li>
      <li>对方说的任何话都要拿出证据证明</li>
      <li>尽量不退让，退让的话底线不能破</li>
    </ol>

    <h1>具体问题</h1>
    
    <h2>如果仲裁员问你是否接受调解</h2>
    <blockquote>
      <p><strong>你可以说</strong>：可以调解，优先结清4天工资；违法解除赔偿可小幅协商</p>
    </blockquote>
    <p>然后仲裁员会问公司如何赔偿</p>
    <blockquote>
      <ol>
        <li>如果能给1周，确定是5天还是7天，要是能达到底线，直接接受调解</li>
        <li>如果给不了，那你不接受调解</li>
      </ol>
    </blockquote>

    <h2>如果仲裁员问你诉求</h2>
    <blockquote>
      <p>第一，请求裁决被申请人支付我在职 4 天的劳动工资；</p>
      <p>第二，请求裁决被申请人支付违法解除劳动关系赔偿金，标准为半个月工资。</p>
      <p>两项合计一共xx元</p>
      <p>xx就是<strong>双方约定月工资 ÷ 月计薪天数 21.75 × 实际出勤 4 天+月工资一半</strong></p>
    </blockquote>

    <h2>如果仲裁员问你你可以要一个月的赔偿，为啥只要半个月</h2>
    <blockquote>
      <p>我个人充分理解公司的困难，为了尽快化解纠纷我自愿放弃半个月的赔偿金</p>
    </blockquote>

    <h2>公司哭穷怎么办</h2>
    <blockquote>
      <p><strong>你可以说</strong>:我非常能理解公司经营的困难，但公司经营风险不能让员工承担，这是违法的，我在岗 4 天正常出勤、没有任何违纪、不胜任的情况。我的主张都是合理并合法的，而且我已经做出了退让，已经充分表现了我的诚意</p>
    </blockquote>

    <h2>公司说你没签合同，不是我的员工</h2>
    <blockquote>
      <p><strong>你可以说</strong>:我提交的微信聊天记录可以证实我是贵公司的员工，而且公司明确通知不用再来上班、作出辞退意思表示，足以证明事实劳动关系存在。</p>
      <p>至于没有劳动合同，是你不和我签，不是我不签</p>
    </blockquote>

    <h2>公司说你只是临时过来试试工、试工不算员工</h2>
    <blockquote>
      <p><strong>你可以说</strong>:劳动法只有试用期没有试工，你后来直接通知不用上班，本质就是单方辞退。</p>
    </blockquote>

    <h2>公司说你不合格没达到要求</h2>
    <blockquote>
      <ol>
        <li>公司说我不合格，请问有具体的考核标准吗？我的工作失误记录》如果有你可以拿出来</li>
        <li>你也从未口头、微信告知我工作存在问题、达不到录用标准</li>
      </ol>
    </blockquote>

    <h2>公司说口头跟你说过你不合适</h2>
    <blockquote>
      <p><strong>你可以说</strong>:我没有听到过，如果你认为你说过请你拿出证据证明</p>
    </blockquote>

    <h2>公司恼怒质问你是不耍无赖</h2>
    <blockquote>
      <ol>
        <li>不要吵架、不要情绪上头</li>
        <li><strong>你可以说</strong>:我不存在耍无赖。我所有主张都有微信聊天记录作为证据支撑，诉求也是合理并合法的，并且我已经做了退让放弃了一半赔偿金，已经充分说明我的诚意了</li>
      </ol>
    </blockquote>

    <h2>试用期不赔偿</h2>
    <blockquote>
      <p><strong>你可以说</strong>:试用期不等于免责期。我被辞退是因为门店卫监局检查问题，和本人工作能力无关。是公司自身的问题</p>
    </blockquote>

    <h2>是你自己不来上班，属于自动离职</h2>
    <blockquote>
      <p>微信记录清晰显示，是你们不让我再来上班的，这就是单方辞退的意思。并非我主动不去工作。不存在自动离职一说</p>
    </blockquote>

    <h2>门店暂时停业整顿，只是暂停上班，不是辞退</h2>
    <blockquote>
      <p>你在微信上明确说的是的是让我不用来了，并没有告诉我何时复工，这就是辞退</p>
    </blockquote>

    <h2>公司说你就工作了4天所以你主张半个月赔偿过高</h2>
    <blockquote>
      <p>工作 4 天同样受劳动法保护。我自愿仅主张半个月赔偿，已经作出让步</p>
    </blockquote>

    <h2>对方否认微信账号是本店工作人员，聊天记录无效</h2>
    <blockquote>
      <p><strong>你可以说</strong>: 该微信全程对接我的入职、日常工作安排以及辞退通知，完整记录用工全过程。我携带原始手机可当庭核验完整聊天记录；对方否认账号归属，请拿出相反证据</p>
    </blockquote>

    <h2>仲裁员劝说只拿工资，直接放弃全部赔偿金</h2>
    <blockquote>
      <p><strong>你可以说</strong>: 我明白仲裁员的调解好意，但公司属于违法解除，我的诉求有法律依据。我愿意少赔一点，但完全不要赔偿金我无法接受</p>
    </blockquote>

    <h2>对方主张我们是劳务合作，不是劳动关系不用赔钱</h2>
    <blockquote>
      <p><strong>你可以说</strong>: 我固定到店上下班，完全听从门店管理安排，薪酬是底薪加提成，不存在平等合作关系，完全符合事实劳动关系特征，劳务关系的说法没有事实依据。</p>
    </blockquote>

    <h2>对方说我没给门店创造收益，不该赔钱</h2>
    <blockquote>
      <p><strong>你可以说</strong>: 只要正常到岗提供劳动，就有权获取工资。你们盈利亏损、经营收益问题属于企业自身风险，不能以此免除违法辞退的赔偿责任。</p>
    </blockquote>
  </div>
</template>

<script>
export default {
  name: 'ArbitrationGuide'
}
</script>

<style scoped>
/* 组件样式继承自全局styles.css */
</style>